import { ExportAllButton } from '../ExportAllButton';
import React, { useState } from 'react';
import { ShowGuesser, FieldGuesser, EditGuesser } from '@api-platform/admin';
import {
  List,
  TextInput,
  TextField,
  BooleanField,
  ReferenceField,
  SimpleShowLayout,
  useRecordContext,
  useGetOne,
  DateField,
  Labeled,
  Datagrid,
  ShowButton,
  EditButton,
  FunctionField,
  SelectInput,
  useGetIdentity,
  CreateButton,
  TopToolbar,
  FilterButton,
  useNotify,
  useRefresh,
} from 'react-admin';
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import {
  InquiryBookerTypes,
  InquirySpamType,
  InquirySpamTypes,
  InquiryTypes,
} from '../../constants/Inquiry';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import { ENTRYPOINT } from '../../config/entrypoint';
import { getSelectedCompanyFilterValue } from '../../helper/filter';
import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';

export const InquiryList = (props) => {
  const filters = [
    <TextInput label="Code" source="course.code" />,
    <TextInput label="Drupal Order" source="drupalOrderId" />,
    <SelectInput
      source="spam"
      choices={[
        {
          id: InquirySpamType.INQUIRY_SPAM_TYPE_NOT_CHECKED,
          name: 'Nicht geprüft',
        },
        {
          id: InquirySpamType.INQUIRY_SPAM_TYPE_POTENTIAL_SPAM,
          name: 'mögl. Spam',
        },
        { id: InquirySpamType.INQUIRY_SPAM_TYPE_SPAM, name: 'Spam' },
        { id: InquirySpamType.INQUIRY_SPAM_TYPE_NOT_SPAM, name: 'Kein Spam' },
      ]}
    />,
  ];

  const companyFilterValue = getSelectedCompanyFilterValue();

  return (
    <List
      {...props}
      actions={<InquiryListActions />}
      filters={filters}
      filter={{ inquiryCompany: companyFilterValue }}
      exporter={inquiryExporter}
    >
      <InquiryListFields />
    </List>
  );
};

export const InquiryListActions = ({}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const sendRequest = () => {
    setLoading(true);
    fetch(`${ENTRYPOINT}/inquiry/delete-spam`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth')}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(response.status);
        }
        response.json().then((data) => {
          notify(`${data.deleted} Spam Messages deleted`, { type: 'success' });
        });
      })
      .catch((reason) => {
        notify(`${reason}`, { type: 'error' });
      })
      .finally(() => {
        setLoading(false);
        refresh();
      });
  };

  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportAllButton />
      <Button
        startIcon={<UnsubscribeIcon />}
        onClick={sendRequest}
        color="primary"
        size={'small'}
        to={`/courses/calendar`}
        disabled={loading}
        sx={{ lineHeight: '1.5' }}
      >
        Spam löschen
      </Button>
    </TopToolbar>
  );
};

export const InquiryListFields = () => {
  return (
    <Datagrid>
      <ReferenceField label="Course" source="course" reference="courses">
        <TextField source="code" />
      </ReferenceField>
      <ReferenceField
        label="CourseCity"
        source="courseCity"
        reference="course_cities"
        link="show"
      >
        <TextField source="cityView" />
      </ReferenceField>
      <ReferenceField
        label="CourseCityDate"
        source="courseCityDate"
        reference="course_city_dates"
        link="show"
      >
        <TextField source="dateView" />
      </ReferenceField>
      <ReferenceField
        label="Guaranteed"
        source="courseCityDate"
        reference="course_city_dates"
        link="show"
      >
        <BooleanField source="guaranteedDate" />
      </ReferenceField>
      <ReferenceField
        label="Company"
        source="inquiryCompany"
        reference="companies"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source={'name'} />
      <FunctionField
        source="inquiryType"
        render={(record) => (
          <Chip
            label={
              InquiryTypes.find(r => r.id === record?.inquiryType)?.name ?? '-'
            }
          />
        )}
      />
      <FunctionField
        source="spam"
        render={(record) => {
          if (record.spam === 0) {
            return (
              <Chip label={InquirySpamTypes.find((t) => t.id === 0).name} />
            );
          }
          if (record.spam === 1) {
            return (
              <Chip
                sx={{ backgroundColor: '#ffc400', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 1).name}
              />
            );
          }
          if (record.spam === 2) {
            return (
              <Chip
                sx={{ backgroundColor: '#f50057', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 2).name}
              />
            );
          }
          if (record.spam === 3) {
            return (
              <Chip
                sx={{ backgroundColor: '#4caf50', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 3).name}
              />
            );
          }
        }}
      />
      <TextField source={'mailSentTo'} />
      <DateField source={'createdAt'} locales={'de'} showTime />
      <ShowButton />
      <EditButton />
    </Datagrid>
  );
};

export const InquiryEdit = (props) => {
  return (
    <EditGuesser {...props}>
      <SelectInput
        required={true}
        source="spam"
        choices={[
          {
            id: InquirySpamType.INQUIRY_SPAM_TYPE_POTENTIAL_SPAM,
            name: 'mögl. Spam',
          },
          { id: InquirySpamType.INQUIRY_SPAM_TYPE_SPAM, name: 'Spam' },
          { id: InquirySpamType.INQUIRY_SPAM_TYPE_NOT_SPAM, name: 'Kein Spam' },
        ]}
      />
    </EditGuesser>
  );
};

export const InquiryShow = (props) => {
  const { data } = useGetIdentity();
  return (
    <>
      <ShowGuesser {...props}>
        <Grid container spacing={2} sx={{ marginTop: 0, p: 0 }}>
          <Grid item xs={6}>
            <InquiryShowFields />
          </Grid>
          <Grid item xs={6}>
            <ParticipantsTable />
            <CheckoutOrderDetails />
            <AlternativeBilling />
          </Grid>
        </Grid>
      </ShowGuesser>
    </>
  );
};

export const InquiryShowFields = (props) => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <SimpleShowLayout>
        <FieldGuesser source={'courseCode'} />
      <ReferenceField label="Course" source="course" reference="courses">
        <TextField label={'Course'} source="code" />
      </ReferenceField>
      <ReferenceField
        label="CourseCity"
        source="courseCity"
        reference="course_cities"
      >
        <TextField source="cityView" />
      </ReferenceField>
      <ReferenceField
        label="CourseCityDate"
        source={'courseCityDate'}
        reference="course_city_dates"
      >
        <TextField source="dateView" />
      </ReferenceField>
      <ReferenceField
        label="Guaranteed"
        source="courseCityDate"
        reference="course_city_dates"
        link="show"
      >
        <BooleanField source="guaranteedDate" />
      </ReferenceField>
      <ReferenceField
        label="Company"
        source="inquiryCompany"
        reference="companies"
      >
        <TextField label={'Company'} source="name" />
      </ReferenceField>
      <ReferenceField label="City" source="contactCity" reference="cities">
        <TextField source="name" />
      </ReferenceField>
      <FieldGuesser source={'gender'} />
      <FieldGuesser source={'name'} />
      <FieldGuesser source={'email'} />
      <FieldGuesser source={'phone'} />
      <FieldGuesser source={'message'} />
      <FieldGuesser source={'drupalOrderId'} />
      <Labeled label={'Checkout-Status'}>
        {record.checkoutStatus ? (
          <Chip
            label={record.checkoutStatus === 'paid' ? 'Bezahlt' : 'Gebucht'}
            color={record.checkoutStatus === 'paid' ? 'success' : 'warning'}
          />
        ) : (
          <span>–</span>
        )}
      </Labeled>
      <FieldGuesser source={'bookedAt'} />
      <FieldGuesser source={'paidAt'} />
      <FieldGuesser source={'currencyCode'} />
      <FieldGuesser source={'online'} />
      <FieldGuesser source={'adCookie'} />
      <Labeled label={'Type'}>
        <Chip
          label={InquiryBookerTypes.find((r) => r.id === record.type).name}
        />
      </Labeled>
      <Labeled label={'InquiryType'}>
        <Chip
          label={
            InquiryTypes.find(r => r.id === record?.inquiryType)?.name ?? '-'
          }
        />
      </Labeled>
      <FunctionField
        source="spam"
        render={(record) => {
          if (record.spam === 0) {
            return (
              <Chip label={InquirySpamTypes.find((t) => t.id === 0).name} />
            );
          }
          if (record.spam === 1) {
            return (
              <Chip
                sx={{ backgroundColor: '#ffc400', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 1).name}
              />
            );
          }
          if (record.spam === 2) {
            return (
              <Chip
                sx={{ backgroundColor: '#f50057', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 2).name}
              />
            );
          }
          if (record.spam === 3) {
            return (
              <Chip
                sx={{ backgroundColor: '#4caf50', color: '#fff' }}
                label={InquirySpamTypes.find((t) => t.id === 3).name}
              />
            );
          }
        }}
      />
      <FieldGuesser source={'ip'} />
      <FieldGuesser source={'referrer'} />
      <FieldGuesser source={'permalink'} />
      <FieldGuesser source={'userAgent'} />
      <FieldGuesser source={'browserResolution'} />
      <FieldGuesser source={'deviceType'} />
      {record.yearsOfService && <FieldGuesser source={'yearsOfService'} />}
      <FieldGuesser source={'createdAt'} />
      <FieldGuesser source={'updatedAt'} />
    </SimpleShowLayout>
  );
};

export const Files = () => {
  const record = useRecordContext();
  const { data, isLoading, error } = useGetOne('inquiries', {
    id: record.id + '/s3Urls',
  });

  if (!record) return null;
  if (!data) return null;
  if (
    !record.applicationFilePath &&
    !record.cvFilePath &&
    !record.testimonyFilePath &&
    !record.additionalFile1Path &&
    !record.additionalFile2Path
  ) {
    return null;
  }

  const attachments = [
    'applicationFileS3Url',
    'cvFileS3Url',
    'testimonyFileS3Url',
    'additionalFile1S3Url',
    'additionalFile2S3Url',
  ];

  return (
    <>
      <Typography sx={{ p: 2 }} variant="h6" component="h6">
        Dateien
      </Typography>
      <SimpleShowLayout>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Type</TableCell>
              <TableCell align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              attachments.map((attachment) => {
                if (data[attachment] === null) return null;
                return (
                  <TableRow>
                    <TableCell align="left">{attachment}</TableCell>
                    <TableCell align="left">
                      <Button href={data[attachment]}>Download</Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </SimpleShowLayout>
    </>
  );
};

export const ParticipantsTable = () => {
  const record = useRecordContext();

  if (!record) return null;
  if (!record.participants) return null;
  if (record.participants.length === 0) return null;

  return (
    <>
      <Typography sx={{ p: 2 }} variant="h6" component="h6">
        Teilnehmer
      </Typography>
      <SimpleShowLayout>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Gender</TableCell>
              <TableCell align="left">Firstname</TableCell>
              <TableCell align="left">Lastname</TableCell>
              <TableCell align="left">E-Mail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record &&
              record.participants &&
              record.participants.map((participant) => (
                <TableRow>
                  <TableCell align="left">{participant.gender}</TableCell>
                  <TableCell align="left">{participant.firstname}</TableCell>
                  <TableCell align="left">{participant.lastname}</TableCell>
                  <TableCell align="left">{participant.email}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </SimpleShowLayout>
    </>
  );
};

export const CheckoutOrderDetails = () => {
  const record = useRecordContext();
  const checkoutData = record?.checkoutData;

  if (!checkoutData) return null;

  return (
    <>
      <Typography sx={{ p: 2 }} variant="h6" component="h6">
        Online-Buchung #{record.drupalOrderId}
      </Typography>
      <SimpleShowLayout>
        <Typography sx={{ px: 2 }}>
          Rechnung: {checkoutData.invoice?.company || ''}{' '}
          {checkoutData.invoice?.firstName || ''}{' '}
          {checkoutData.invoice?.lastName || ''}
        </Typography>
        <Typography sx={{ px: 2 }}>
          {checkoutData.invoice?.street || ''},{' '}
          {checkoutData.invoice?.postcode || ''}{' '}
          {checkoutData.invoice?.city || ''}
        </Typography>
        <Table sx={{ minWidth: 650 }} aria-label="checkout items">
          <TableHead>
            <TableRow>
              <TableCell>Seminar</TableCell>
              <TableCell>Termin / Ort</TableCell>
              <TableCell>Teilnehmer</TableCell>
              <TableCell align="right">Preis</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(checkoutData.items || []).map((item, index) => (
              <TableRow key={`${item.courseCityDateDrupalId}-${index}`}>
                <TableCell>{item.title}</TableCell>
                <TableCell>
                  {item.startDate} – {item.endDate}
                  <br />
                  {item.location}
                </TableCell>
                <TableCell>
                  {(item.participants || []).map(
                    (participant, participantIndex) => (
                      <Box
                        key={`${participant.email || 'participant'}-${participantIndex}`}
                        sx={{ mb: participantIndex + 1 < item.participants.length ? 1 : 0 }}
                      >
                        <div>
                          {participant.firstName} {participant.lastName}
                        </div>
                        {participant.email && <div>{participant.email}</div>}
                        {participant.phone && <div>{participant.phone}</div>}
                      </Box>
                    ),
                  )}
                </TableCell>
                <TableCell align="right">
                  {item.totalPrice} {item.currencyCode}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography sx={{ p: 2, textAlign: 'right', fontWeight: 700 }}>
          Gesamt: {checkoutData.totalPrice} {checkoutData.currencyCode}
        </Typography>
      </SimpleShowLayout>
    </>
  );
};

export const AlternativeBilling = () => {
  const record = useRecordContext();
  if (!record) return null;
  if (!record.altBilling) return null;

  return (
    <>
      <Typography sx={{ p: 2 }} variant="h6" component="h6">
        Alternative Billing Address
      </Typography>
      <SimpleShowLayout record={record}>
        <Box display="flex" sx={{ p: 2 }}>
          <Box
            display="flex"
            flexWrap="wrap"
            flexDirection={'column'}
            sx={{ width: '50%' }}
          >
            <TextField label={'Type'} source={'altType'} />
            <TextField label={'Company'} source={'altCompany'} />
            <TextField label={'Department'} source={'altDepartment'} />
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            flexDirection={'column'}
            sx={{ width: '50%' }}
          >
            <TextField label={'Firstname'} source={'altFirstname'} />
            <TextField label={'Lastname'} source={'altLastname'} />
            <TextField label={'Address'} source={'altAddress'} />
            <TextField label={'Postcode'} source={'altPostcode'} />
            <TextField label={'City'} source={'altCity'} />
          </Box>
        </Box>
      </SimpleShowLayout>
    </>
  );
};

const inquiryExporter = async (records, fetchRelatedRecords) => {

  const courses = await fetchRelatedRecords(records, 'course', 'courses');

  const courseCities = await fetchRelatedRecords(
    records,
    'courseCity',
    'course_cities'
  );

  const cities = await fetchRelatedRecords(
    Object.values(courseCities),
    'city',
    'cities'
  );

  const data = records.map((record) => {
    const course = courses[record.course];
    const courseCity = courseCities[record.courseCity];
    const city = cities[courseCity?.city];

    return {
      ...record,
      courseTitle: course?.translations?.de?.title || '',
      cityTitle: city?.name || '',
    };
  });

  jsonExport(data, (err, csv) => {
    downloadCSV(csv, 'inquiries');
  });
};
